import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../base";
import { MasterPlan } from "../../domain/models/master-plan";
import { PlanningPortalRepository } from "../../repositories";
import { MasterPlansRequest } from "../../domain/requests";

@Injectable({providedIn: 'root'})
export class GetMasterPlanForMLSUsecase implements UseCase<MasterPlansRequest, MasterPlan[]> {

  constructor(private planningPortalRepository: PlanningPortalRepository) {
  }

  execute(params: MasterPlansRequest): Observable<MasterPlan[]> {
    return this.planningPortalRepository.GetMasterPlanForMLS(params);
  }
}
